import React from "react";
import { EventPageUiLabels } from "../templates/event";
import LinkWithButtonStyle from "./LinkWithButtonStyle";
import ExternalLinkIcon from "./icons/ExternalLinkIcon";
import PlusIcon from "./icons/PlusIcon";

interface Props {
  location: Queries.EventPageQuery["datoCmsEvent"]["location"][0];
  registrationLink: Queries.EventPageQuery["datoCmsEvent"]["sectionRegistration"][0]["registrationLink"];
  additionalInformation: Queries.EventPageQuery["datoCmsEvent"]["sectionRegistration"]["0"]["additionalInformation"];
  uiLabels: EventPageUiLabels;
}

const RegistrationButtons = ({
  location,
  registrationLink,
  additionalInformation,
  uiLabels,
}: Props) => {
  const registrationLabel = uiLabels.buttonRegister;
  const renderAdditionalInformation = () => {
    if (additionalInformation.length === 0) return null;

    const button = additionalInformation[0];
    if (Object.prototype.hasOwnProperty.call(button, "googleMapsLink")) {
      const label = uiLabels.buttonGetDirections;
      const {
        streetAndNumber,
        zipcode,
        city,
        country: { label: country },
      } = location as unknown as Queries.DatoCmsEventPagePhysicalLocation;
      const query = encodeURI(
        `${streetAndNumber}, ${zipcode}, ${city}, ${country}`
      );

      return (
        <LinkWithButtonStyle
          to={`https://www.google.com/maps/search/?api=1&query=${query}`}
          type="outline"
          label={label}
          iconRight={<ExternalLinkIcon size={12} />}
          external
        />
      );
    } else {
      const label = uiLabels.buttonAddToCalendar;
      const { url, filename } = (
        button as Queries.DatoCmsEventPageAdditionalInformationCalendar
      ).calendarFile;

      return (
        <LinkWithButtonStyle
          to={url}
          title={filename}
          label={label}
          type="outline"
          iconRight={<PlusIcon size={12} />}
          external
          download
        />
      );
    }
  };
  return (
    <div className="mt-8 flex flex-wrap gap-4" data-datocms-noindex>
      <LinkWithButtonStyle
        to={registrationLink}
        label={registrationLabel}
        type="filled"
        external
      />
      {renderAdditionalInformation()}
    </div>
  );
};

export default RegistrationButtons;
